import { useSyncExternalStore } from 'react'

/**
 * Phone width (design 12.2: "managers can approve from their phone"; 4-03, X-10). The same breakpoint as
 * Tailwind's `max-md:` classes and the phone rules in styles.css, so the shell, the desk and the pages agree.
 */
export const PHONE_QUERY = '(max-width: 767.98px)'

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {}
      const m = window.matchMedia(query)
      m.addEventListener('change', onChange)
      return () => m.removeEventListener('change', onChange)
    },
    () => (typeof window !== 'undefined' && !!window.matchMedia ? window.matchMedia(query).matches : false),
    () => false,
  )
}

/** True at phone width: the shell shows a top bar with a menu drawer, and the desk is one column. */
export const useIsPhone = () => useMediaQuery(PHONE_QUERY)
